import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: 'EN',
    scrollPercentage: 0,
    openingVideo: false,
  },
  getters:{
    language: state => {
      return state.language;
    },
    scrollPercentage: state => {
      return state.scrollPercentage;
    },
    openingVideo: state => {
      return state.openingVideo;
    }
  },
  mutations: {
    setLanguage: function (state, newValue)  {
      state.language = newValue;
    },
    setScrollPercentage: function (state, newValue) {
      state.scrollPercentage = newValue;
    },
    setOpeningVideo: function (state, newValue){
      state.openingVideo = newValue;
    }
  },
  actions: {
  },
  modules: {
  }
})
